import { Container, Grid, Box, useTheme, Divider } from "@mui/material";

import useResponsive from "@/hooks/useResponsive";

import AppButtons from "./AppButtons";
import FooterLogo from "./FooterLogo";
import FooterLinks from "./FooterLinks";
import LegalSection from "./LegalSection";

const Footer = () => {
  const theme = useTheme();
  const isTablet = useResponsive("down", "md");
  const isDesktop = useResponsive("up", "md");

  return (
    <Box
      component="footer"
      bgcolor={theme.palette.grey[800]}
      pt={5}
      pb={{ xs: 2.5, md: 4.25 }}
    >
      <Container>
        {isTablet ? (
          <>
            <FooterLogo />
            <AppButtons />
            <Grid container rowSpacing={5} columnSpacing={2} mb={4}>
              <FooterLinks />
            </Grid>
          </>
        ) : (
          <>
            <Grid container spacing={{ md: 1, lg: 2 }} mb={{ md: 11.25 }}>
              <Grid item md={2.7} lg={2.25}>
                <FooterLogo />
              </Grid>
              <FooterLinks />
              <Grid
                item
                md={1.8}
                lg={3.75}
                sx={{
                  display: { xs: "block", md: "flex" },
                  justifyContent: "end",
                }}
              >
                <AppButtons />
              </Grid>
            </Grid>
          </>
        )}
      </Container>

      {isDesktop && <Divider sx={{ backgroundColor: "white", opacity: 0.2 }} />}

      <Container>
        <LegalSection />
      </Container>
    </Box>
  );
};

export default Footer;
